module.exports = __webpack_public_path__ + "static/media/features-split-image-03.0f48f4e0.png";